import axios from "axios";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Leaf, Search, Upload, History, Layers } from "lucide-react";

import "@/App.css";

import LookupPage from "./pages/LookupPage";
import BulkPage from "./pages/BulkPage";
import HistoryPage from "./pages/HistoryPage";
import RangesPage from "./pages/RangesPage";

import {
  NAV,
  SidebarNavItem,
  MobileNavItem,
  SidebarBrand,
  SidebarFooter,
} from "./components/Navigation";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

const ICONS = { Search, Upload, History, Layers };

function Sidebar() {
  return (
    <aside
      data-testid="app-sidebar"
      className="hidden md:flex md:w-64 shrink-0 flex-col border-r border-border/60 bg-white relative overflow-hidden"
    >
      <SidebarBrand />
      <nav className="flex flex-col gap-1 p-4">
        {NAV.map((item) => (
          <SidebarNavItem key={item.to} item={item} Icon={ICONS[item.iconKey]} />
        ))}
      </nav>
      <SidebarFooter />
    </aside>
  );
}

function MobileTopBar() {
  return (
    <div className="md:hidden sticky top-0 z-20 bg-white border-b border-border/60 px-4 py-3 flex items-center gap-3">
      <div className="h-8 w-8 rounded-lg bg-[#1A3626] flex items-center justify-center text-white">
        <Leaf className="h-4 w-4" strokeWidth={1.5} />
      </div>
      <div className="font-heading tracking-tight text-[#111812]">Wetland.lookup</div>
      <div className="ml-auto flex gap-1">
        {NAV.map((item) => (
          <MobileNavItem key={item.to} item={item} Icon={ICONS[item.iconKey]} />
        ))}
      </div>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen flex bg-[#F9F9F8] text-[#111812] font-body">
        <Sidebar />
        <div className="flex-1 flex flex-col min-w-0">
          <MobileTopBar />
          <main className="flex-1" data-testid="app-main">
            <Routes>
              <Route path="/" element={<LookupPage />} />
              <Route path="/bulk" element={<BulkPage />} />
              <Route path="/history" element={<HistoryPage />} />
              <Route path="/ranges" element={<RangesPage />} />
            </Routes>
          </main>
        </div>
      </div>
      <Toaster position="top-right" richColors />
    </BrowserRouter>
  );
}
